<template>
    <div>
        <app-template>
            <!-- Header -->
            <div class="flex items-center justify-between mb-6">
                <h2 class="text-xl font-bold">
                    <i class="fas fa-file-contract mr-2"></i>
                    Contrats d’entretien
                </h2>

                <button
                    @click="openModalCreate"
                    class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    <i class="fas fa-plus mr-2"></i>
                    Créer un contrat
                </button>
            </div>

            <!-- Filtres -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                        Statut du contrat
                    </label>
                    <select
                        v-model="filters.status"
                        class="border rounded px-3 py-2 w-full"
                    >
                        <option value="">Tous</option>
                        <option value="en_cours">Contrats en cours</option>
                        <option value="termine">Contrats terminés</option>
                    </select>
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                        Numéro de contrat
                    </label>
                    <input
                        v-model="filters.numero"
                        @keyup.enter="fetchContrats"
                        type="text"
                        placeholder="Numéro de contrat"
                        class="border rounded px-3 py-2 w-full"
                    />
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                        Client
                    </label>
                    <input
                        v-model="filters.client"
                        @keyup.enter="fetchContrats"
                        type="text"
                        placeholder="Client"
                        class="border rounded px-3 py-2 w-full"
                    />
                </div>
            </div>

            <!-- Table -->
            <div v-if="loadingGetContrats">
                <div class="flex justify-center items-center py-10">
                    <i class="fas fa-spinner fa-spin text-2xl text-gray-500"></i>
                </div>
            </div>
            <div v-if="!loadingGetContrats && !contrats.length" class="py-10 text-center text-gray-500">
                Aucun contrat trouvé avec les filtres sélectionnés.
            </div>
            <div v-if="!loadingGetContrats && contrats.length" class="overflow-x-auto bg-white rounded shadow">
                <table class="min-w-full text-sm">
                    <thead class="bg-gray-100 text-gray-700">
                        <tr>
                            <th class="px-4 py-3 text-left">N°</th>
                            <th class="px-4 py-3 text-left">Client</th>
                            <th class="px-4 py-3 text-left">Date début</th>
                            <th class="px-4 py-3 text-left">Date fin</th>
                            <th class="px-4 py-3 text-left">Prix</th>
                            <th class="px-4 py-3 text-left">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="contrat in contrats" :key="contrat.id" class="border-t">
                            <td class="px-4 py-2 font-mono">
                                {{ contrat.numero_contrat }}
                            </td>

                            <td class="px-4 py-2">
                                {{ contrat.client?.nom ?? '-' }}
                            </td>

                            <td class="px-4 py-2">
                                {{ contrat.date_debut | momentDate }}
                            </td>

                            <td class="px-4 py-2">
                                {{ contrat.date_fin | momentDate }}
                            </td>

                            <td class="px-4 py-2">
                                {{ contrat.prix.toFixed(2) }} €
                            </td>

                            <td class="px-4 py-2">
                                <a
                                    :href="contrat.url"
                                    target="_blank"
                                    class="inline-flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 transition-colors"
                                >
                                    <i class="fas fa-eye mr-1.5"></i>
                                    Voir le contrat
                                </a>
                                <button v-if="!isEnded(contrat)" @click="resilierContrat(contrat.id, contrat.client?.nom ?? '')" class="inline-flex items-center px-3 py-1.5 bg-red-600 text-white text-xs font-medium rounded hover:bg-red-700 transition-colors ml-2">
                                    <i class="fas fa-times mr-1.5"></i>
                                    Résilier
                                </button>
                            </td>
                        </tr>

                        <tr v-if="!contrats.length">
                            <td colspan="5" class="text-center py-6 text-gray-400">
                                Aucun contrat trouvé
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                v-if="!loadingGetContrats && pagination.last_page > 1"
                class="flex items-center justify-between mt-6"
            >
                <div class="text-sm text-gray-500">
                    {{ pagination.total }} contrats
                </div>

                <div class="flex items-center gap-2">
                    <button
                        @click="fetchContrats(pagination.page - 1)"
                        :disabled="pagination.page === 1"
                        class="px-3 py-1 border rounded disabled:opacity-40"
                    >
                        Précédent
                    </button>

                    <span class="text-sm">
                        Page {{ pagination.page }} / {{ pagination.last_page }}
                    </span>

                    <button
                        @click="fetchContrats(pagination.page + 1)"
                        :disabled="pagination.page === pagination.last_page"
                        class="px-3 py-1 border rounded disabled:opacity-40"
                    >
                        Suivant
                    </button>
                </div>
            </div>

            <!-- MODALE CREATION -->
            <modal
                name="create-contrat-entretien"
                height="auto"
                :scrollable="true"
            >
                <div class="p-6">
                    <h3 class="text-lg font-bold mb-4">
                        Créer un contrat d’entretien
                    </h3>

                    <template v-if="!selectedClient">
                        <div class="col-span-3">
                            <label class="text-sm font-medium text-gray-700">Rechercher un client</label>
                            <div class="relative mt-1">
                                <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                <input v-model="inpSearchClient" type="text"
                                    placeholder="Nom, société, email, téléphone..."
                                    class="pl-9 w-full rounded-lg border border-gray-300 focus:outline-none text-sm py-2">
                            </div>

                            <template v-if="loadingSearchClients">
                                <div class="flex justify-center items-center py-6">
                                    <i class="fas fa-spinner fa-spin text-2xl text-gray-500"></i>
                                </div>
                            </template>

                            <template v-if="!loadingSearchClients">
                                <div v-for="(client, clientIndex) in clients" :key="clientIndex" class="mt-2">
                                    <div
                                        @click="selectClient(client)"
                                        class="cursor-pointer p-2 border rounded hover:bg-gray-100"
                                    >
                                        <div>{{ client.prenom }} - {{ client.nom }}</div>
                                        <div class="text-sm font-light" v-if="client.societe">{{ client.societe }}</div>
                                        <div class="text-sm font-light">{{ client.email }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>

                    <div v-if="selectedClient" class="space-y-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">
                                Appareil <span class="text-red-500">*</span>
                            </label>
                            <select @change="checkHasContrat" v-model="form.appareil_id" class="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none" id="inp-appareil">
                                <option value="" disabled>Sélectionner un appareil</option>
                                <option v-for="appareil in selectedClient.appareils" :key="appareil.id" :value="appareil.id">
                                    {{ appareil.marque }} - {{ appareil.model }}
                                </option>
                            </select>
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">
                                Adresse <span class="text-red-500">*</span>
                            </label>
                            <select @change="checkHasContrat" v-model="form.adresse_id" class="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none" id="inp-adresse">
                                <option value="" disabled>Sélectionner une adresse</option>
                                <option v-for="adresse in selectedClient.adresses" :key="adresse.id" :value="adresse.id">
                                    {{ adresse.adresse1 }}, {{ adresse.code_postal }} {{ adresse.ville }}
                                </option>
                            </select>
                        </div>

                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-1">
                                    Date de début <span class="text-red-500">*</span>
                                </label>
                                <input
                                    v-model="form.date_debut"
                                    type="date"
                                    class="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none"
                                    id="inp-date_debut"
                                />
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-1">
                                    Date de fin <span class="text-red-500">*</span>
                                </label>
                                <input
                                    v-model="form.date_fin"
                                    type="date"
                                    class="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none"
                                    id="inp-date_fin"
                                />
                            </div>
                        </div>

                        <!-- <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">
                                Récurrence (mois)
                            </label>
                            <input
                                v-model="form.recurence_mois"
                                type="number"
                                placeholder="12"
                                class="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none"
                            />
                        </div> -->

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">
                                Prix (€) <span class="text-red-500">*</span>
                            </label>
                            <input
                                v-model="form.prix"
                                type="number"
                                step="0.01"
                                placeholder="0.00"
                                class="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none"
                                id="inp-prix"
                            />
                        </div>
                    </div>

                    <div v-if="contratExists">
                        <div class="mt-4 p-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700">
                            <strong>Attention :</strong> Un contrat d’entretien existe déjà pour cet appareil à cette adresse.<br/>
                            Numéro de contrat existant : <strong>{{ contratExists.contrat.numero_contrat }}</strong><br/>
                            Date de début : <strong>{{ contratExists.contrat.date_debut | momentDate }}</strong><br/>
                            Date de fin : <strong>{{ contratExists.contrat.date_fin | momentDate }}</strong><br/>
                            Prix : <strong>{{ contratExists.contrat.prix.toFixed(2) }} €</strong>
                        </div>
                    </div>

                    <div v-if="selectedClient" class="flex justify-end gap-3 mt-6">
                        <button
                            @click="$modal.hide('create-contrat-entretien')"
                            class="px-4 py-2 rounded border"
                        >
                            Annuler
                        </button>

                        <button
                            @click="createContrat"
                            :disabled="loading"
                            class="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                        >
                            <i class="fas fa-spinner fa-spin mr-2" v-if="loading"></i>
                            Créer le contrat
                        </button>
                    </div>
                </div>
            </modal>
        </app-template>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    watch: {
        filters: {
            deep: true,
            handler() {
                this.pagination.page = 1;
                this.fetchContrats(1);
            },
        },

        inpSearchClient: function(newVal) {
            this.searchClient()
        },
    },

    data() {
        return {
            contrats: [],

            pagination: {
                page: 1,
                last_page: 1,
                total: 0,
            },
            per_page: 50,

            filters: {
                numero: '',
                client: '',
                date_debut: '',
                date_fin: '',
                status: 'en_cours',
            },

            inpSearchClient: '',
            selectedClient: null,
            clients: [],
            timeOutSearchClient: null,
            contratExists: null,

            form: {
                appareil_id: '',
                adresse_id: '',
                date_debut: '',
                date_fin: '',
                recurence_mois: 12,
                prix: 0,
            },

            fetchTimeout: null,

            loading: false,
            loadingGetContrats: false,
            loadingSearchClients: false,
        };
    },

    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },

    methods: {
        async fetchContrats(page = 1) {
            clearTimeout(this.fetchTimeout);

            this.fetchTimeout = setTimeout(async () => {
                this.loadingGetContrats = true;
                this.pagination.page = page;

                const res = await this.$request.get(
                    '/contrats/contrat-entretien/contrat-entretiens',
                    {
                        params: {
                            ...this.filters,
                            page: this.pagination.page,
                            per_page: this.per_page,
                        },
                    }
                );

                this.contrats = res.data;
                this.pagination.last_page = res.last_page;
                this.pagination.total = res.total;

                this.loadingGetContrats = false;
            }, 400);
        },

        createContrat() {
            const validation = this.$inpError([
                'inp-appareil:required',
                'inp-adresse:required',
                'inp-date_debut:required|date',
                'inp-date_fin:required|date',
                'inp-prix:required|numeric|min=0',
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            this.loading = true;

            this.$request.post('/contrats/contrat-entretien/create', this.form)
                .then(() => {
                    this.$modal.hide('create-contrat-entretien');
                    this.fetchContrats();
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        openModalCreate() {
            this.selectedClient = null;
            this.inpSearchClient = '';
            this.clients = [];
            this.contratExists = null;
            this.form = {
                appareil_id: '',
                adresse_id: '',
                date_debut: '',
                date_fin: '',
                recurence_mois: 12,
                prix: this.$account.account.societe?.tarif_contrat_entretien || 0,
            };
            this.$modal.show('create-contrat-entretien');
        },

        async searchClient() {
            clearTimeout(this.timeOutSearchClient);
            this.timeOutSearchClient = setTimeout(async () => {
                this.loadingSearchClients = true;
                const res = await this.$request.get('/clients', {
                    params: {
                        search: this.inpSearchClient,
                        limit: 10,
                        with_adresses: 1,
                        with_appareils: 1,
                    },
                });
                this.loadingSearchClients = false;

                // Handle the search results as needed
                this.clients = res.data;
            }, 300);
        },

        selectClient(client) {
            this.selectedClient = client;
            this.form.appareil_id = client.appareils.length ? client.appareils[0].id : '';
            this.form.adresse_id = client.adresses.length ? client.adresses[0].id : '';
            this.form.date_debut = moment().format('YYYY-MM-DD');
            this.form.date_fin = moment().add(1, 'year').format('YYYY-MM-DD');
            this.checkHasContrat();
        },

        async checkHasContrat() {
            if (!this.form.appareil_id || !this.form.adresse_id) {
                return;
            }

            const res = await this.$request.post('/contrats/contrat-entretien/check-existing', {
                appareil_id: this.form.appareil_id,
                adresse_id: this.form.adresse_id,
            });

            if (res.exists) {
                this.contratExists = res
            } else {
                this.contratExists = null
            }
        },

        async resilierContrat(contratId, clientName) {
            if (!confirm(`Êtes-vous sûr de vouloir résilier le contrat avec ${clientName} ?`)) {
                return;
            }

            await this.$request.post(`/contrats/contrat-entretien/contrat-entretiens/${contratId}/resilier`);
            this.fetchContrats();
        },

        isEnded(contrat) {
            return moment(contrat.date_fin).isBefore(moment());
        },
    },

    mounted() {
        this.fetchContrats();
    },
};
</script>
